import React, { Suspense } from 'react';
import { PageLoading } from '@/components';
import { ArcoProvider } from './ArcoProvider';
import { AuthProvider } from './AuthProvider';
import { ErrorBoundaryProvider } from './ErrorBoundaryProvider';
import { ReactQueryProvider } from './ReactQueryProvider';
import { ThemeProvider } from './ThemeProvider';
import { ReactRouterProvider } from './ReactRouterProvider';
export const AppProvider = () => {
  return /*#__PURE__*/React.createElement(Suspense, {
    fallback: /*#__PURE__*/React.createElement(PageLoading, null)
  }, /*#__PURE__*/React.createElement(ErrorBoundaryProvider, null, /*#__PURE__*/React.createElement(ThemeProvider, null, /*#__PURE__*/React.createElement(ArcoProvider, null, /*#__PURE__*/React.createElement(ReactQueryProvider, null, /*#__PURE__*/React.createElement(AuthProvider, null, /*#__PURE__*/React.createElement(ReactRouterProvider, null)))))));
};